import React from 'react';
import { useI18n } from '../utils/i18n';
import { Ticket } from 'lucide-react';
import '../styles/Dashboard.css';

const EmailContextMenu = ({ email, position, onClose, onTicketCreated, onShowTicketModal }) => {
  
  const { t } = useI18n();
  // useEffect und loadOpenTickets wurden entfernt, da in EmailList verlagert

  const handleAddToTicket = () => {
    onShowTicketModal && onShowTicketModal();
    onClose(); // Schließe das Context-Menu
  };





          
            
            
              
            
            
            

  // Portal wurde nach EmailList verlagert
  
  return (
    <div 
      className="context-menu"
      style={{
        position: 'fixed',
        top: position.y,
        left: position.x,
        zIndex: 1000,
        backgroundColor: 'white',
        border: '1px solid var(--color-border-strong)',
        borderRadius: '4px',
        boxShadow: '0 2px 10px var(--color-shadow-10)',
        padding: '8px 0',
        minWidth: '200px'
      }}
    >
      <div 
        className="context-menu-item"
        onClick={handleAddToTicket}
        style={{
          padding: '8px 16px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}
        onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--color-surface-hover)'}
        onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
      >
        <Ticket size={16} />
        {t('email.addToTicket.button', 'Zu einem Ticket hinzufügen')}
      </div>
    </div>
  );
};

export default EmailContextMenu; 